import React from 'react';
import Q1Conclusion from './Q1Conclusion';
import Q1Header from './Q1Header';
import Q1Row1 from './Q1Row1';
import Q1Row2 from './Q1Row2';
import Q1Row3 from './Q1Row3';

function StoryQ1() {
  return (
    <>
      <Q1Header />
      <Q1Row1 />
      <div className="pagebreak80" />
      <Q1Row2 />
      <div className="pagebreak80" />
      <Q1Row3 />
      <Q1Conclusion />
    </>
  );
}

export default StoryQ1;
